module.exports = __webpack_public_path__ + "img/main.10f37079.jpg";